import Home from '../views/pages/Home.vue'
import { i18n } from '../plugins/i18n'
import NotFound from '../views/pages/404.vue'

export default [
  {
    path: '/',
    redirect: `/${i18n.locale}`
  },
  {
    path: '/:lang',
    component: {
      render (c) { return c('router-view') }
    },
    children: [
      {
        path: '/',
        name: 'home',
        component: Home
      },
      {
        path: '*',
        component: NotFound
      }
    ]
  }
]
